import { isArray as _isArray } from "lodash-es";
import React, { useCallback } from "react";
import Linkify from "linkify-react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import tw from "tailwind-styled-components";

import parse from "./parser";
import { setHumansFilterQuery } from "../../actions/humans";
import { getHumanUrl } from "../../utils";
import Badge from "../Badge";

export const TagWrapper = tw.span`
cursor-pointer
text-blue-500
hover:text-blue-600
`;

export const LinkWrapper = tw.a`
text-blue-500
hover:text-blue-600
`;

const linkifyOptions = {
  className: "text-blue-500 hover:text-blue-600",
  rel: "noopener noreferrer",
  target: "_blank",
};

const MarkupRender = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const setQuery = useCallback(
    (query) => {
      if (!window.matchMedia("(min-width: 1024px)").matches) {
        // if not `lg` (Tailwind) size (mobile), redirect to human list
        history.push("/h");
      }
      return dispatch(setHumansFilterQuery({ searchTerm: query }));
    },
    [dispatch, history],
  );

  const humans = useSelector((state) => state.humans);

  if (!children) return children;

  if (typeof children === "string") {
    return renderStringToElements(children, setQuery, humans);
  }

  if (_isArray(children)) {
    return children.map((item) => {
      if (typeof item === "string") {
        return renderStringToElements(item, setQuery, humans);
      } else if (item.length) {
        return (
          item && item.map((i) => renderStringToElements(i, setQuery, humans))
        );
      }
      return item;
    });
  }

  return children;
};

const renderStringToElements = (value, setQuery, humans) => {
  if (typeof value !== "string") return value;

  const entities = parse(value);
  const out = [];
  let i = 0;

  for (const entity of entities) {
    i++;

    if (typeof entity === "string") {
      out.push(entity);
    } else if (entity.type === "tag") {
      out.push(
        <TagWrapper
          key={`t${i}`}
          onClick={(e) => {
            e.stopPropagation();
            setQuery(entity.text);
          }}
        >
          {entity.text}
        </TagWrapper>,
      );
    } else if (entity.type === "usertag") {
      let human = humans.find((h) => h.id === entity.humanId);
      if (!human) {
        human = {
          id: entity.humanId,
          name: entity.name,
        };
      }

      out.push(
        <Badge key={`ut${i}`}>
          {" "}
          <Link to={getHumanUrl(human)}>{human.name}</Link>
        </Badge>,
      );
    } else if (entity.type === "phone") {
      out.push(
        <LinkWrapper key={`phone${i}`} href={`tel:${entity.num}`}>
          {entity.text}
        </LinkWrapper>,
      );
    }
  }

  return out;
};

const Markup = ({ children }) => (
  <Linkify options={linkifyOptions}>
    <MarkupRender>{children}</MarkupRender>
  </Linkify>
);

Markup.propTypes = {
  children: PropTypes.any.isRequired,
};

export default Markup;
